import { useEffect } from "react";
import { ActivityScreen } from "../screens/activity/ActivityScreen.js";
import { MessageScreen } from "../screens/activity/MessageScreen.js";
import { ActionsScreen } from "../screens/actions/ActionsScreen.js";
import { EditActionScreen } from "../screens/actions/EditActionScreen.js";
import { NewActionScreen } from "../screens/actions/NewActionScreen.js";
import { ApprovalsScreen } from "../screens/approvals/ApprovalsScreen.js";
import { LoginScreen } from "../screens/auth/LoginScreen.js";
import { StartScreen } from "../screens/auth/StartScreen.js";
import { TokenScreen } from "../screens/auth/TokenScreen.js";
import { SettingsScreen } from "../screens/settings/SettingsScreen.js";
import { SetupScreen } from "../screens/setup/SetupScreen.js";
import { PageSpinner } from "../ui/index.js";
import { type Route, navigate, useRoute } from "./router.js";
import { useSession } from "./services.js";
import { Shell } from "./Shell.js";
import { TenantProvider } from "./tenant.js";

function Redirect({ to }: { to: string }) {
  useEffect(() => {
    navigate(to, { replace: true });
  }, [to]);
  return <PageSpinner />;
}

function TenantScreen({ route }: { route: Route }) {
  switch (route.name) {
    case "setup":
      return <SetupScreen />;
    case "message":
      return <MessageScreen id={route.id} />;
    case "actions":
      return <ActionsScreen />;
    case "actionNew":
      return <NewActionScreen from={route.from} />;
    case "actionEdit":
      return <EditActionScreen id={route.id} />;
    case "approvals":
      return <ApprovalsScreen />;
    case "settings":
      return <SettingsScreen />;
    case "activity":
    case "login":
    case "loginToken":
    case "invite":
    case "start":
      return <ActivityScreen />;
  }
}

export function App() {
  const route = useRoute();
  const session = useSession();

  if (route.name === "loginToken") return <TokenScreen key={route.token} kind="login" token={route.token} />;
  if (route.name === "invite") return <TokenScreen key={route.token} kind="invite" token={route.token} />;
  if (session === null) return route.name === "login" ? <LoginScreen /> : <Redirect to="/login" />;
  if (route.name === "login") return <Redirect to="/activity" />;
  if (route.name === "start") return <StartScreen domain={route.domain} />;
  if (session.active === null) return <Redirect to="/start" />;

  return (
    <TenantProvider key={session.active}>
      <Shell route={route.name}>
        <TenantScreen route={route} />
      </Shell>
    </TenantProvider>
  );
}
